/**
 * 代驾单类型
 */
export enum DRIVING_ORDER_TYPE {
  /**
   * 1：取车单
   */
  get = 1,
  /**
   * 2：还车单
   */
  return = 2,
}

/**
 * 子订单状态
 */
export enum SUB_ORDER_STATUS {
  /**
   * 1=已下单
   */
  ordered = 1,
  /**
   * 2=资金已冻结
   */
  frozen = 2,
  /**
   * 3=订单取消
   */
  canceled = 3,
  /**
   * 4=等待司机接单
   */
  waitingDriver = 4,
  /**
   * 5=司机已接单
   */
  driverAccepted = 5,
  /**
   * 6=司机已开启订单
   */
  driverStarted = 6,
  /**
   * 7=司机已就位
   */
  driverArrived = 7,
  /**
   * 8=司机开车中
   */
  driving = 8,
  /**
   * 9=司机到达目的地
   */
  arrived = 9,
  /**
   * 10=已收车
   */
  received = 10,
  /**
   * 11=订单已完成
   */
  completed = 11,
}
